import { createStore } from "redux";
import rootReducer from "./reducer";

const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(localStorage.getItem("reduxState"))
  : {};

const store = createStore(rootReducer, persistedState);

// for debuging redux strore (only in development environment)
// const store = createStore(rootReducer, persistedState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

//store.subscribe(() => {

//  localStorage.setItem("reduxState", JSON.stringify(store.getState()));
//});

export default store;
